import React from "react";
import { Form } from "react-bootstrap";
import { FieldProps } from "formik";
import SelectOption from "./helpers/SelectOption";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const Select: React.FC<FormikFieldCustomProps &
  FieldProps & { handleBlur: () => {}; handleChange: (value: any) => {}, defaultselected?:any }> = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  let error = errors[field.name];
  let touch = touched[field.name];
  return (
    <Form.Group controlId={field.name}>
      {props.label && (
        <Form.Label>
          {props.required ? <b>{props.label}</b> : props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      <Form.Control
        as="select"
        {...field}
        {...props}
        name={field.name}
        value={field.value}
        onChange={(change: any) => {
          setFieldValue(field.name, change.target.value);
          if (props.handleChange) {
            props.handleChange(change.target.value);
          }
        }}
        isInvalid={Boolean(touched[field.name] && errors[field.name])}
        error={touch && error && <Form.Text>{error}</Form.Text>}
        onBlur={props.handleBlur}
      >
        {props.defaultselected && 
          <option disabled value="" defaultValue={props.defaultselected}>{props.defaultselected}</option>
        }
        {props.options.map((vl: SelectOption) => (
          <option value={vl.value} key={vl.value}>
            {vl.label}
          </option>
        ))}
      </Form.Control>
      {error && <div className="error-sel">{error}</div>}
    </Form.Group>
  );
};

export default Select;
